import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class SystemEventBus extends BaseBus
{
    constructor(busObj: SystemEventBus = null) {
        super(busObj);
    }
    CID(): any {
        return this.systemEventId;
    }

    systemEventId: any;
    eventName: string;
    eventDescription: string;
    isActive: boolean;

}
